module.exports = __webpack_public_path__ + "img/cooperacion_msh.116b9be8.jpg";